import React from 'react'
import Placed from './Placed'
import Received from './Received'

const PlacedAndReceived = ({bidType}) => {
  return (
    <>
        {bidType == "Placed" ? <Placed/> : <Received/>}
    </>
  )
}

export default PlacedAndReceived